import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { Typography, DialogTitle, DialogActions } from '@material-ui/core';
import { deleteProduct } from './other/actions';

/**
 * Dialog qui s'affiche quand on veut supprimer un produit de l'import
 */
const DialogDeleteProduct = ({
  isOpen,
  product,
  index,
  onDelete,
  handleCloseDialogDeleteProduct
}) => (
  <Dialog open={isOpen} onClose={() => handleCloseDialogDeleteProduct()}>
    <DialogTitle id="alert-dialog-title">Supprimer ce produit ?</DialogTitle>
    <DialogContent style={{ padding: 20, width: '70vh', height: '30vh' }}>
      <Typography>
        Produit : {product.reference} / {product.name} ?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button
        color="primary"
        variant="contained"
        style={{ width: '100%' }}
        onClick={() => {
          onDelete(index);
          handleCloseDialogDeleteProduct();
        }}
      >
        Supprimer
      </Button>
      <Button
        color="secondary"
        variant="contained"
        style={{ width: '100%', marginTop: 30 }}
        onClick={() => {
          handleCloseDialogDeleteProduct();
        }}
      >
        Annuler
      </Button>
    </DialogActions>
  </Dialog>
);

const mapDispatchToProps = dispatch => ({
  dispatchDeleteProduct: (data, index) => dispatch(deleteProduct(data, index))
});

DialogDeleteProduct.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  product: PropTypes.object.isRequired,
  handleCloseDialogDeleteProduct: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired
};

export default connect(null, mapDispatchToProps)(DialogDeleteProduct);
